import { flow, ReadonlyArray, Runtime } from "fp";
import { QueryKey } from "react-query";

import { ID, Reference } from "~/Data";
import * as Log from "~/Log";
import { Request } from "~/Request";
import { Time } from "~/Time";

export const toEndpoint = ({ id, date }: Query.QueryParams) =>
  `/elogs/drivers/${id}/violations?start_date=${date}&end_date=${date}`;

export namespace Query {
  export const tag = () => "Violations" as const;

  export type QueryKeyParams = {
    readonly id: ID.ID;
  };

  export type QueryParams = Reference.Reference & {
    readonly date: string;
  };

  export const id = ({ driver, dateTime }: Log.Identity): ID.ID =>
    `${driver.id}-${Time.DateTime.toISOWithoutTime({ dateTime })}`;

  export const key = (id: QueryKeyParams): QueryKey => [tag(), id];

  export const request = ({
    dateTime,
    driver,
  }: Log.Identity): Request.Fn<readonly Log.Violation.Violation[]> => {
    const date = Time.DateTime.toISOLocalWithoutTime({ dateTime });
    return flow(
      Request.fromConfig({
        endpoint: toEndpoint({ id: driver.id, date }),
      }),
      Request.Expect.status(200),
      Request.Expect.json(Runtime.array(Log.Violation.Response.runtime())),
      Request.onSuccess(ReadonlyArray.map(Log.Violation.Response.decode))
    );
  };
}
